import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { AppState } from '../../../../app.reducer';
import { setLoadingResolve } from '../../store/ui.actions';

@Component({
  selector: 'ngx-token-error',
  templateUrl: './token-error.component.html',
  styleUrls: ['./token-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TokenErrorComponent implements OnInit {
  errorMessage = 'Session expired, please refresh the page to try again';
  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store.dispatch(setLoadingResolve({ value: false }));
  }
}
